const paymentOptions = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_PAYMENT_OPTIONS_SUCCESS':
      return action.paymentOptions
    default:
      return state
  }
}

export default paymentOptions

export const selectCurrentPaymentOptions = (state) => {
  return state.refis.paymentOptions || []
}
